import { PlantsListSerializer } from '../serializers/PlantsListSerializer'

const p = new PlantsListSerializer({})

export const state = () => ({
    asd: null
})
